import * as React from 'react';
import { Input } from 'reactstrap';
import Add from '@material-ui/icons/Add';
import Remove from '@material-ui/icons/Remove';
import { useTranslations } from '../../../../store/translations/hooks';
import { TK } from '../../../../store/translations/translationKeys';
import Typography from '../../../../components/Typography';
import { IconButton } from '@mui/material';
import AppButton from '../../../../components/AppButton';


export interface TableColumnsFieldProps {
    id?: string,
    columns: string[],
    widths: (string | undefined)[],
    disabled?: boolean,
    onChange: (columns: string[], widths: (string | undefined)[]) => void,
}

export const TableColumnsField = (props: TableColumnsFieldProps) => {
    const {
        id,
        columns,
        widths,
        onChange,
        disabled,
    } = props;
    
    const t = useTranslations()

    const onColumnChanged = (column: string, idx: number) => {
        onChange(columns.map((v, i) => i === idx ? column : v), widths)
    }

    const onWidthChanged = (width: string | undefined, idx: number) => {
        widths[idx] = width
        onChange(columns, widths)
    }

    return (
        <div>
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <Typography size='smaller'>{t(TK.name)}</Typography>
                <Typography size='smaller' style={{marginRight: 'var(--spacer-L)'}}>{t(TK.widthPercentage)}</Typography>
            </div>
            {   
                columns.map((column, idx) => (
                    <div key={idx} style={{display: 'flex', gap: 'var(--spacer-XS)'}}>
                        <Input
                            id={id ? `${id}-${idx}-column-input` : undefined}
                            disabled={disabled}
                            type='text' 
                            value={column || ''}
                            onChange={e => onColumnChanged(e.target.value, idx)}/>
                        <Input
                            style={{width: '5rem'}}
                            id={id ? `${id}-${idx}-width-input` : undefined}
                            disabled={disabled}
                            type='number'
                            min={0}
                            max={100} 
                            value={widths[idx]}
                            onChange={e => onWidthChanged(e.target.value == '0' ? undefined : e.target.value.toString(), idx)}/>
                        { !disabled && 
                            <IconButton
                                id={id ? `${id}-${idx}-remove-button` : undefined}
                                onClick={() => onChange(columns.filter((_, i) => i !== idx), widths.filter((_, i) => i !== idx))}
                                size="small"
                            >
                                <Remove/>
                            </IconButton>
                        }
                    </div>
                ))
            }
            { !disabled && 
                <div style={{textAlign: 'end', width: '100%'}}>
                    <IconButton
                        id={id ? `${id}-add-button` : undefined}
                        onClick={() => onChange(columns.concat(''), widths.concat(''))}
                        size="small"
                    >
                        <Add/>
                    </IconButton>
                </div>
            }
        </div>
    );
}
